import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/api/auth.service';
import { LangService } from 'src/app/core/lang.service';
import { LoginGuardService } from '../../api/login-guard.service';
import { RoutesService } from "../../api/routes.service";
import {Router} from '@angular/router';
import { NotificationService } from 'src/app/api/notifications/notification.service';
import { NotificationCentre } from 'src/app/api/notifications/data/types';
import { AccountType } from 'src/app/constants/account-types';
import { WhitelabelService } from 'src/app/domain/whitelabel.service';
@Component({
  selector: 'view-login-portal',
  templateUrl: './view-login-portal.component.html',
  styleUrls: ['./view-login-portal.component.scss']
})
export class ViewLoginPortalComponent implements OnInit {

  constructor(
    private auth:AuthService,
    private lang:LangService,
    public loginGuard: LoginGuardService,
    public notifications: NotificationService,
    private routes: RoutesService,
    private router: Router,
    private whitelabel: WhitelabelService
  ) { }

  fullName:string;
  accountTypes:any = [];
  accountTypelocalStorageAffix = 'accountTypes:'
  accessToken
  scorerNotificationCounts: { [key: string]: number } = {};
  profileCompletionStatus: { [key: string]: boolean } = {}; // Track profile completion for each account
  hasUnviewedInvitedTask: boolean = false; // A new task has been invited but not yet viewed by the scorer

  public userNotifications: NotificationCentre.IUserMessage[];

  ngOnInit(): void {

    this.auth.user().subscribe(async userInfo => {
      if (userInfo) {
        this.fullName = userInfo.firstName +' ' + userInfo.lastName
        const lang = this.lang.c();
        this.accessToken = userInfo.accessToken
        const accountTypelocalStoragePhrase = this.accountTypelocalStorageAffix+userInfo.accessToken
        const savedAccountTypes = JSON.parse(localStorage.getItem(accountTypelocalStoragePhrase) || 'null');

        const replaceProps = (str:string, params:any) => {
          Object.keys(params).forEach(paramKey => {
            str = str.split(':'+paramKey).join(params[paramKey])
          });
          return str;
        };

        const fromServer = (userInfo.accountTypes || []).map(record => {
          const {route_template, group_id} = record;
          record.route = '#'+replaceProps(route_template, {
            lang,
            group_id,
          })
          return record;
        });

        if (savedAccountTypes && Array.isArray(savedAccountTypes)) {
          fromServer.forEach(at => {
            const saved = savedAccountTypes.find(
              s => s.ur_id === at.ur_id && s.group_id === at.group_id
            );
            if (saved && +saved.is_confirmed === 1) {
              at.is_confirmed = 1;
            }
          });
        }

        this.accountTypes = fromServer;
        localStorage.setItem(accountTypelocalStoragePhrase, JSON.stringify(this.accountTypes));

        this.loadScorerNotificationCounts();
        await this.loadProfileCompletionStatus();
        this.checkUnviewedInvitedTasks();
        this.updateLastCheckedIn();
      }

      this.notifications.onNotificationsLoaded.subscribe((notifications: NotificationCentre.IUserMessage[]) => {
        this.userNotifications = notifications;
      });
    })

  }

  private updateLastCheckedIn(): void {
    // Update LastCheckedIn for scor-scor users when they land on this page
    const isScorerUser = this.accountTypes.some(accountType => accountType.account_type === AccountType.SCOR_SCOR);
    
    if (isScorerUser) {
      const uid = this.auth.getUid();
      if (!uid) return;

      const now = new Date().toISOString();
      
      this.auth.apiPatch('public/profile/user-info', uid, {
        lastCheckedIn: now
      }, { query: { namespace_context: this.whitelabel.context.toLowerCase() }
      }).catch(err => {
        console.error('Failed to update LastCheckedIn:', err);
      });
    }
  }


  showConfirmBtn(accountType){
    if(+accountType.is_conf_req === 1 && +accountType.is_confirmed === 0){
      return true;
    }
    return false;
  }

  /**
   * Get Not My __(institution) slug
   * @param account_type 
   * @returns 
   */
  getNotMyInstitutionSlug(account_type:AccountType) {
    switch(account_type) {
      case AccountType.SCHOOL_DISTRICT_CURRI:
      case AccountType.DIST_ADMIN:
        return 'lp-button-not-my-board'
      case AccountType.SCHOOL_ADMIN:
        return 'lp-button-not-my-school'
      default:
        return 'lp-button-not-my-school'
    }
  }

  confirmBtnClick(accountType){
    const ur_id = accountType.ur_id
    const uid = this.auth.getUid();
    this.auth.apiPatch(this.routes.LANDING_CONFIRM_USER_ROLE, ur_id, {}, { query: { uid, group_id: accountType.group_id} })
      .then(res => {
        if(+res.is_confirmed === 1 && +accountType.is_confirmed === 0){
          accountType.is_confirmed = 1
          const accountTypelocalStoragePhrase = this.accountTypelocalStorageAffix+ this.accessToken
          localStorage.setItem(accountTypelocalStoragePhrase, JSON.stringify(this.accountTypes));
        }
      })
  }

  notMySchoolBtnClick(accountType){
    const ur_id = accountType.ur_id
    const uid = this.auth.getUid();
    const account_type = accountType.account_type
    const confirmationMsg = this.lang.tra(this.getNotMyRoleWarningMsg(account_type));
    this.loginGuard.confirmationReqActivate({
      caption: confirmationMsg,
      confirm: () => {
        //revoke user role(s)
        this.auth.apiRemove(this.routes.LANDING_CONFIRM_USER_ROLE, ur_id, { query: { uid, group_id: accountType.group_id} })
        //remove role portal link button
        const i = this.accountTypes.indexOf(accountType);
        this.accountTypes.splice(i, 1);
        const accountTypelocalStoragePhrase = this.accountTypelocalStorageAffix+ this.accessToken
        localStorage.setItem(accountTypelocalStoragePhrase, JSON.stringify(this.accountTypes));
      }
    })
  }

  /**
   * Get "Not My __" popup warning message by account_type
   * @param account_type 
   * @returns 
   */
  getNotMyRoleWarningMsg(account_type:AccountType) {
    switch(account_type) {
      case AccountType.SCHOOL_DISTRICT_CURRI:
        return 'lp_not_dist_curri_warning'
      case AccountType.DIST_ADMIN:
        return 'lp_not_dist_admin_warning'
      case AccountType.SCHOOL_ADMIN:
        return 'lp_not_schl_admin_warning'
      default:
        return 'lp_not_schl_admin_warning'
    }
  }

  getAccountNotifications(accountType) {
    // const accountNotifications = this.notifications.getNotificationsByGroup(accountType.group_id);
    const accountNotifications = this.notifications.getNotificationsByRole(accountType.ur_id, accountType.group_id);
    return this.notifications.unreadNotifications(accountNotifications);
  }

  private loadScorerNotificationCounts(): void {
    // Load scorer notification counts for all SCOR_SCOR account types
    this.accountTypes.forEach(accountType => {
      if (accountType.account_type === AccountType.SCOR_SCOR && accountType.caption !== 'lbl_profile_details') {
        this.notifications.getScorerNotificationsCount()
          .then(count => {
            this.scorerNotificationCounts[accountType.ur_id] = count;
          })
          .catch(err => {
            console.error('Failed to load scorer notification count:', err);
            this.scorerNotificationCounts[accountType.ur_id] = 0;
          });
      }
    });
  }

  private async loadProfileCompletionStatus(): Promise<void> {
    const scorers = this.accountTypes.filter(accountType =>
      accountType.account_type === AccountType.SCOR_SCOR && accountType.caption === 'lbl_profile_details'
    );
    // Resolve each profile tile sequentially rather than concurrently, per
    // workspace policy on batched profile requests.
    for (const accountType of scorers) {
      await this.checkUserProfileCompletion(accountType);
    }
  }

  private async checkUserProfileCompletion(accountType): Promise<void> {
    try {
      const uid = this.auth.getUid();
      if (!uid) return;

      // Get user_metas to check ProfileCompleted status
      const userMetas = await this.auth.apiFind('public/profile/user-info', { 
        query: { uid: uid, namespace_context: this.whitelabel.context.toLowerCase() } 
      });

      if (userMetas && userMetas.length > 0) {
        const userData = userMetas[0];
        // Check if ProfileCompleted is set to true/1
        this.profileCompletionStatus[accountType.ur_id] = 
          userData.profileCompleted === '1' || userData.profileCompleted === 1 || userData.profileCompleted === true;
      } else {
        // If no profile data found, assume incomplete
        this.profileCompletionStatus[accountType.ur_id] = false;
      }
    } catch (error) {
      console.error('Failed to check profile completion:', error);
      // Default to incomplete on error
      this.profileCompletionStatus[accountType.ur_id] = false;
    }
  }

  shouldShowProfileWarning(accountType): boolean {
    return accountType.account_type === AccountType.SCOR_SCOR &&
           accountType.caption === 'lbl_profile_details' &&
           this.profileCompletionStatus[accountType.ur_id] === false;
  }

  // A new task has been invited (invited=1) but the scorer has not yet opened My
  // Tasks (viewed=0). Read-only — does NOT mark the invitations viewed.
  private async checkUnviewedInvitedTasks(): Promise<void> {
    try {
      const uid = this.auth.getUid();
      if (!uid) return;
      const resp: any = await this.auth.apiFind('public/scor-scor/scorer-task-invitations', {
        query: {
          scorer_uid: uid,
          invited: 1,
          show_current: true,
          namespace_context: this.whitelabel.context.toLowerCase()
        }
      });
      const rows: any[] = (resp && typeof resp === 'object' && 'data' in resp) ? (resp.data || []) : (Array.isArray(resp) ? resp : []);
      this.hasUnviewedInvitedTask = rows.some(r => !r.viewed);
    } catch (e) {
      this.hasUnviewedInvitedTask = false;
    }
  }

  // Same exclamation on the Profile Details card for a new (unviewed) task invitation.
  shouldShowTaskWarning(accountType): boolean {
    return accountType.account_type === AccountType.SCOR_SCOR &&
           accountType.caption === 'lbl_profile_details' &&
           this.hasUnviewedInvitedTask;
  }

  getPortalWarningTooltip(accountType): string {
    const incomplete = this.shouldShowProfileWarning(accountType);
    const newTask = this.shouldShowTaskWarning(accountType);
    if (incomplete && newTask) return this.lang.tra('tooltip_profile_and_new_task');
    if (newTask) return this.lang.tra('tooltip_new_task_invitation');
    return this.lang.tra('tooltip_complete_profile');
  }

  getTotalNotificationCount(accountType): number {
    const regularCount = this.getAccountNotifications(accountType).length;
    // The message centre lives behind the scoring tile, so its unread count is
    // shown there only. Profile Details carries the completion warning instead,
    // and showing both left the two indicators sitting side by side.
    const scorerCount = accountType.account_type === AccountType.SCOR_SCOR &&
      accountType.caption !== 'lbl_profile_details' ?
      (this.scorerNotificationCounts[accountType.ur_id] || 0) : 0;
    return regularCount + scorerCount;
  }

  storeCurrentAccountType(accountType) {
    this.auth.storeCurrentAccountType(accountType);
  }
}
